import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [['Belén M.', 'Córdoba, Argentina', 'Combo Ventas Sin Publicidad'], ['Sofía R.', 'Rosario, Argentina', 'Combo + IA para Emprendedores'], ['Martín A.', 'Mendoza, Argentina', 'Combo Ventas Sin Publicidad'], ['Carolina G.', 'La Plata, Argentina', 'Combo + IA para Emprendedores'], ['Julieta P.', 'Mar del Plata, Argentina', 'Combo Ventas Sin Publicidad']];
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [number, setNumber] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialTimer = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(initialTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hideTimer = window.setTimeout(() => setVisible(false), 5500);
    const nextTimer = window.setTimeout(() => {
      setNumber(value => (value + 1) % purchases.length);
      setVisible(true);
    }, 14500);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [visible, dismissed]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, city, plan] = purchases[number];
  return <>
      <AnimatePresence data-id="element-189" data-mp="wk3lgmmg7eqb">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 32,
        scale: 0.94
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 32,
        scale: 0.94
      }} className="fixed bottom-4 left-4 z-[60] w-[min(320px,calc(100vw-2rem))] overflow-hidden rounded-2xl border-2 border-[#ff2d75] bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(7,59,92,.42)] ring-4 ring-gold/70" aria-live="polite" data-id="element-190" data-mp="11fiyjccmt6lo">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-[#ff2d75]" data-id="element-191" data-mp="3gaghsj32r21u" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-sky-200 transition-colors hover:bg-white/10 hover:text-white" aria-label="Cerrar notificación" data-id="element-192" data-mp="3gcjfzqeds1hn">
              <XIcon className="h-3.5 w-3.5" data-id="element-193" data-mp="3l8i0v40i31db" />
            </button>
            <div className="flex gap-3" data-id="element-194" data-mp="33oimy0a8ged">
              <span className="rounded-full border-2 border-white/70 bg-gold p-2 text-primary shadow-sm" data-id="element-195" data-mp="32n7yun6hvx6">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-196" data-mp="3uar73hoqk8kw" />
              </span>
              <div data-id="element-197" data-mp="24wco7e0effxb">
                <p className="flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[.12em] text-gold" data-id="element-198" data-mp="24vtgsr8dk9xj">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-199" data-mp="1zyb7gzqg3sp0" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-sky-50" data-id="element-200" data-mp="fexuorg8tm3p">
                  <b className="text-white" data-id="element-201" data-mp="kbxrscv47eio">{name}</b> compró el libro digital{' '}
                  <b className="text-gold" data-id="element-202" data-mp="6mnkvb99fimz">{plan}</b>
                </p>
                <p className="mt-1 inline-flex items-center gap-1 rounded-full border border-[#ff2d75]/70 bg-[#ff2d75]/15 px-2 py-1 text-[10px] font-bold text-white" data-id="element-203" data-mp="anfva7tvbtku">
                  <MapPinIcon className="h-3 w-3 text-gold" data-id="element-204" data-mp="3srr9gv16mw1b" /> 🇦🇷 {city} · hace {number * 7 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-205" data-mp="3juqokydbng2m">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-[#d81f2a] py-3.5 text-center font-display text-sm font-bold text-white shadow-lg shadow-red-700/30" data-id="element-206" data-mp="3nt7nwvqi3m9h">
            QUIERO VENDER SIN PUBLICIDAD →
          </motion.a>}
      </AnimatePresence>
    </>;
}